import { Extension } from '@tiptap/core'

const Color = Extension.create({
  name: 'color',

  addOptions() {
    return {
      types: ['textStyle']
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (element) => element.style.color || null,
            renderHTML: (attributes) => {
              if (!attributes.color) {
                return {}
              }

              return { style: `color: ${attributes.color}` }
            }
          },
          backgroundColor: {
            default: null,
            parseHTML: (element) => element.style.backgroundColor || null,
            renderHTML: (attributes) => {
              if (!attributes.backgroundColor) {
                return {}
              }

              return { style: `background-color: ${attributes.backgroundColor}` }
            }
          }
        }
      }
    ]
  }
})

export default Color
